<template>
<v-app id="app">
	<router-view/>
</v-app>
</template>
<script>

export default {
	name: 'App'
}
</script>

<style lang="scss">
@import './assets/global.scss';
.v-tabs__div {
    &.v-tab-end {
        margin-left: auto;
    }

    &.v-tab-action {
        background-color: $primary-color;
    }
}

.v-tabs__slider {
    height: 6px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue